// extracted by mini-css-extract-plugin
export default {"section":"burger-constructor_section__IR4uo","list":"burger-constructor_list__ehxn5","list__scroll":"burger-constructor_list__scroll__Y5UWD","hint":"burger-constructor_hint__o70eh"};